const config = require("config");

(function() {
  "use strict";

  angular
    .module("alk.maps")
    .directive("alkmap", ["$rootScope", "$location", "ALKMaps", "mapService", "UserProvider",
      "Messages", "$translate", "$timeout", "$window", "savedMapInfo", "mapUtilities" ,"$injector",
      function($rootScope, $location, ALKMaps, mapService, UserProvider,
        Messages, $translate, $timeout, $window, savedMapInfo, mapUtilities, $injector) {

        // Tile loading error counts
        var errorCount = 0;
        var userInfo;
        var availableRegions;
        if (UserProvider.getUser().isLoggedIn) {
          userInfo = UserProvider.getUser();
          availableRegions = userInfo.availableRegions || [ userInfo.region ];
        } else {
          userInfo = {
            region: "NA",
            dataVersion: "Current"
          };
          availableRegions = [ "NA" ];
        }
        const baseLayerDefs = mapUtilities.getMapBaseLayerDefs();

        availableRegions.sort((a, b) => {
          return baseLayerDefs[a].index - baseLayerDefs[b].index;
        });

        var disableAddCenterParam = false;

        /**
         * Tile load error handler
         */
        function onTileError() {
          errorCount++;
        }

        /**
         * Tile load start handler
         */
        function onLoadStart() {
          errorCount = 0;
        }

        /**
         * Tile load end handler
         */
        function onLoadEnd() {
          var scope = this;
          if (errorCount > 0) {
            errorCount = 0;

            Messages.add("danger", $translate.instant("common.relogin"));
            UserProvider.clearUser();
            $location.path("/login");

            if (!scope.$$phase) {scope.$apply();}
          }
        }

        /**
         * Map move end handler
         * For one data version web apps like MapSure, MapExact or Content Tools account with only one data version, only update center params
         * For multiple data versions Content Tools, add logic to switch base layers and region/dataVersion/gridDataVersion in userInfo automatically
         */
        function onMoveEnd() {
          var baseLayers = this.baseLayers;
          var scope = this.scope;
          var map = scope.map;
          if (map == null)
          {return;}

          $timeout(() => {
            scope.keyboardControl.activate();
            updateUrlCenterParameter(scope);
            $rootScope.$broadcast("MapMove");
          });

          // multiple data region support scenario
          if (baseLayers.length > 1) {
            var mapCenter = map.center.clone();
            mapCenter.transform(map.getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));
            // Code originated from Rishi.
            var newRegion = mapUtilities.getRegionFromLonLat(mapCenter.lon, mapCenter.lat);

            /*
              After we get the new region, we need to check if the account has access to the base layer for this region, such as NAMap, OCMap..
              If user does not have access but has access to WWMap, then use WWMap instead
              If neither, do nothing
            */
            var newRegionLayer = _.find(map.layers, {name : `${newRegion  }Map` }) || _.find(map.layers, {name : "WWMap" });
            if (!newRegionLayer) {
              newRegion = userInfo.region;
            } else if (newRegionLayer.name == "WWMap") {
              newRegion = "WW";
            }

            // if it zooms to a new region, need to update region and data version saved in userInfo
            if (userInfo.region != newRegion) {
              userInfo.region = newRegion;
              userInfo.dataVersion = `PCM_${  newRegion}`;
              map.setBaseLayer(_.find(map.layers, {name: `${newRegion  }Map`}));

              // if app has constantsService in injector, needs to call getConstants to update gridDataVersion too.
              if ($injector.has("constantsService")) {
                $injector.get("constantsService").getConstants(userInfo.dataVersion).then((PCMWS_CONSTANTS) => {
                  userInfo.gridDataVersion = PCMWS_CONSTANTS.gridDataVersion;
                  UserProvider.loadUser(userInfo);
                  $rootScope.$broadcast("RegionUpdated");
                });
              }
            }
          }

        }

        /**
         * Creates base layers.
         */
        function createBaseLayers(scope, savedInfo) {
          var layers = [];
          var availableBaseLayers = [];
          // add one or more base layers. Note the first layer should be set to default base layer
          for (var i = 0; i < availableRegions.length; i++) {
            availableBaseLayers.push(baseLayerDefs[availableRegions[i]]);
          }

          for (var layerIndex = 0; layerIndex < availableBaseLayers.length; layerIndex++) {

            var layerDef = availableBaseLayers[layerIndex];
            var baseLayer = new ALKMaps.Layer.BaseMap(layerDef.name, {
              region: layerDef.region,
              dataset: layerDef.dataset
            }, {
              localLanguage: true,
              wrapDateLine: true,
              isBaseLayer: layerIndex === 0 ? true : false,
              visibility:layerIndex === 0 ? true : false
            });
            baseLayer.setSatelliteImageSource(scope.mapSatelliteProvider || 0);
            baseLayer.events.register("tileerror", scope, onTileError);
            baseLayer.events.register("loadstart", scope, onLoadStart);
            baseLayer.events.register("loadend", scope, onLoadEnd);
            layers.push(baseLayer);
          }

          return layers;
        }

        /**
         * Creates click handler
         */
        function createClickHandler(scope) {
          var c = new ALKMaps.Handler.Click(
            new ALKMaps.Control(), {
              click: function() {
                if (scope.keyboardControl) {scope.keyboardControl.activate();}
                $rootScope.$broadcast("MapClickHandler");
              }
            }, {
              single: true
            }
          );

          return c;
        }

        /**
         *  Updates URL center parameter
         */
        function updateUrlCenterParameter(scope) {
          if (scope.addCenterParam !== false && disableAddCenterParam === false) {
            var center = scope.map.getCenter().transform(scope.map.getProjectionObject(), new ALKMaps.Projection("EPSG:4326")),
              zoom = scope.map.getZoom(),
              precision = Math.max(0, Math.ceil(Math.log(zoom) / Math.LN2));

            var urlCenterParam = [zoom, center.lat.toFixed(precision), center.lon.toFixed(precision)].join(",");
            savedMapInfo.saveCurrentInfo(scope.map.getCenter(), scope.map.getZoom(), scope.map.style);
            $location.search("center", urlCenterParam);
          }
        }

        /**
         * Link
         */
        function link(scope, element, attrs) {
          if (UserProvider.getUser() && UserProvider.getUser().authToken) {
            {ALKMaps.APIKey = `${config.alkmapsApiKey  }|${  UserProvider.getUser().authToken}`;}
          }

          if ($window.localStorage.getItem("jwtToken")) {
            {ALKMaps.APIKey = `${config.alkmapsApiKey } ` ;}
          }

          // set the initial language of the map
          if ($translate.use()) {
            ALKMaps.Lang.setCode($translate.use().substring(0, 2));
          }

          // watch for changes to the locale and update the map and controls
          $rootScope.$on("$localeChangeSuccess", (e, locale) => {
            ALKMaps.Lang.setCode(locale.substring(0, 2));
          });

          var mapId = attrs.id || "map";
          scope.elementWithFocus = false;
          scope.keyboardControl = null;
          scope.navControl = null;
          var savedInfo = savedMapInfo.getSavedInfo();
          scope.map = mapService.getMap();
          scope.map.render(mapId);
          var baseLayers = createBaseLayers(scope, savedInfo);
          scope.map.addLayers(baseLayers);
          scope.map.setBaseLayer(baseLayers[0]);
          scope.map.setCenter(savedInfo.mapCenter, savedInfo.mapZoom);
          var c = createClickHandler(scope);
          c.setMap(scope.map);
          c.activate();
          scope.map.events.register("moveend", {
            scope: scope,
            baseLayers: baseLayers
          }, onMoveEnd);

          //Handle disabling of map keyboard tracking for specific input controls
          for (var i = 0; i < scope.map.controls.length; i++) {
            if (scope.map.controls[i].displayClass === "olControlKeyboardDefaults") {
              scope.keyboardControl = scope.map.controls[i];
            }
          }

          scope.$on("MapInputFocus", (event, message) => { // jshint ignore:line
            scope.keyboardControl.deactivate();
            scope.elementWithFocus = message;
          });

          scope.$on("MapInputBlur", (/*event, message */) => {
            scope.keyboardControl.activate();
            scope.elementWithFocus = false;
          });

          $rootScope.$on("DisableAddCenterParam", () => {
            disableAddCenterParam = true;
          });

          scope.$on("$destroy", () => {
            mapService.releaseMap();
            var layerIndex;
            for (layerIndex = 0; layerIndex < baseLayers.length; layerIndex++) {
              var basemap = baseLayers[layerIndex];
              basemap.events.unregister("tileerror", scope, onTileError);
              basemap.events.unregister("loadstart", scope, onLoadStart);
              basemap.events.unregister("loadend", scope, onLoadEnd);
              scope.map.removeLayer(basemap);
            }
            scope.map.events.unregister("moveend", {
              scope: scope,
              baseLayers: baseLayers
            }, onMoveEnd);
            c.deactivate();
            scope.map = null;
            errorCount = 0;
          });

          updateUrlCenterParameter(scope);
        }

        // Usage: <div alkmap id="map" map-satellite-provider="{{userInfo.satelliteProvider}}" map-region="userInfo.region" map-dataset="userInfo.dataVersion" multiple-data-region="true"></div>
        //
        // Creates:
        //TODO: add attribs for center and zoom
        var directive = {
          link: link,
          restrict: "AE",
          scope: {
            apikey: "@",
            mapSatelliteProvider: "@",
            mapDataset: "=",
            mapRegion: "=",
            multipleDataRegion: "=", // If true, regional street map layers will be used instead of the one base layer.
            addCenterParam: "="
          }
        };

        return directive;
      }
    ]);
})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/alkmaps.directive.js